import React from "react";
import createBaseRenderer from "./createBaseRenderer";

import { useServerMessage } from "b2b/i18n";

export default createBaseRenderer({
  name: "doplnkoveSluzbyNazev",
  content: ({ val }) => {
    const message = useServerMessage();
    return (
      <>
        {val.map(item => (
          <div key={item.id}>{message(item, "nazev")}</div>
        ))}
      </>
    );
  }
});
